"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Breadcrumb = _interopRequireDefault(require("../Breadcrumb"));

require("./style.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _default = {
  name: 'WithHeader',
  data: function data() {
    return {};
  },
  methods: {
    routeFormat: function routeFormat() {
      var routes = this.$route.matched;
      var list = [];
      routes.forEach(function (route) {
        var meta = route.meta,
            name = route.name,
            path = route.path,
            redirect = route.redirect;
        list.push({
          meta: meta,
          name: name,
          path: path,
          redirect: redirect
        });
      });
      return list;
    }
  },
  render: function render() {
    var h = arguments[0];
    var content = this.$slots.content;
    var menuData = this.routeFormat();

    var route = _toConsumableArray(menuData).pop(0);

    return h("div", {
      "class": "page-header-warp"
    }, [h("div", {
      "class": "page-header"
    }, [h(_Breadcrumb.default, {
      "attrs": {
        "menuData": menuData
      }
    }), h("div", {
      "class": "page-header-heading"
    }, [route.meta.title]), content && h("div", {
      "class": "page-header-content"
    }, [content])]), this.$slots.default]);
  }
};
exports.default = _default;